import React from 'react';
import { GRID } from '@/constants/testIds';

export function StateBadge({ state }) {
  if (state === 'available') {
    return (
      <span
        data-testid={GRID.cardStateBadge}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#DEEFE4] px-2.5 py-1 text-xs font-bold text-[#1E3A2F]"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#1E3A2F]" />
        Available
      </span>
    );
  }
  if (state === 'reserved') {
    return (
      <span
        data-testid={GRID.cardStateBadge}
        className="inline-flex items-center gap-1.5 rounded-full bg-[#EEF0EE] px-2.5 py-1 text-xs font-bold text-[#4A544D]"
      >
        On hold
      </span>
    );
  }
  if (state === 'sponsored') {
    return (
      <span data-testid={GRID.cardStateBadge} className="sponsored-badge">Sponsored</span>
    );
  }
  return null;
}
